import { ReactNode, createContext, useMemo } from "react";

import { SocketContextData } from "./socket.types";
import { useSocket } from "./useSocket";

export const SocketsContext = createContext<SocketContextData>({
  orderSocket: {
    socket: null,
    isConnected: false
  },
  resellerSocket: {
    socket: null,
    isConnected: false
  },
  earningsSocket: {
    socket: null,
    isConnected: false
  },
  refundsSocket: {
    socket: null,
    isConnected: false
  },
  damagedItemsSocket: {
    socket: null,
    isConnected: false
  },
  chatSocket: {
    socket: null,
    isConnected: false
  },
  whatsappBotAdminSocket: {
    socket: null,
    isConnected: false
  },
  inAppSupportAdminSocket: {
    socket: null,
    isConnected: false
  },
  supportTicketsAdminSocket: {
    socket: null,
    isConnected: false
  }
});

export const SocketsProvider = ({ children }: { children: ReactNode }) => {
  const orderSocket = useSocket({
    pathName: "order",
    onConnectEmitEvents: ["subscribe-to-counts"]
  });

  const resellerSocket = useSocket({
    pathName: "reseller",
    onConnectEmitEvents: ["subscribe-to-unverified-resellers-count"]
  });

  const earningsSocket = useSocket({
    pathName: "earning",
    onConnectEmitEvents: ["subscribe-to-available-to-be-paid-earnings-count"]
  });

  const refundsSocket = useSocket({
    pathName: "refund",
    onConnectEmitEvents: ["subscribe-to-unrefunded-refunds-count"]
  });

  const damagedItemsSocket = useSocket({
    pathName: "damaged-item",
    onConnectEmitEvents: ["subscribe-to-damaged-items-count"]
  });

  const chatSocket = useSocket({
    pathName: "chat",
    onConnectEmitEvents: ["subscribe-to-helpcrunch-new-customer-message"]
  });

  const whatsappBotAdminSocket = useSocket({
    pathName: "whatsapp-bot-admin",
    onConnectEmitEvents: ["subscribe-to-conversations"]
  });

  const inAppSupportAdminSocket = useSocket({
    pathName: "in-app-support-admin",
    onConnectEmitEvents: ["subscribe-to-conversations"]
  });

  const supportTicketsAdminSocket = useSocket({
    pathName: "support-tickets-admin",
    onConnectEmitEvents: ["subscribe-to-support-tickets"]
  });

  const value = useMemo(
    () => ({
      orderSocket,
      resellerSocket,
      earningsSocket,
      refundsSocket,
      damagedItemsSocket,
      chatSocket,
      whatsappBotAdminSocket,
      inAppSupportAdminSocket,
      supportTicketsAdminSocket
    }),
    [
      orderSocket,
      resellerSocket,
      earningsSocket,
      refundsSocket,
      damagedItemsSocket,
      chatSocket,
      whatsappBotAdminSocket,
      inAppSupportAdminSocket,
      supportTicketsAdminSocket
    ]
  );

  return (
    <SocketsContext.Provider value={value}>{children}</SocketsContext.Provider>
  );
};
